import * as THREE from 'three';
import ObjectArrayView from '../../generic/container/ObjectArrayView';
import ObjectsByName from '../../generic/container/ObjectsByName';
import PolyMesh from '../model/PolyMesh';
import PolyMap from '../model/PolyMap';
import cleanPolyMesh from '../operator/cleanPolyMesh';

export default function Lathe(points, norms, segments, phiStart, phiLength) {
  //assumes one normal per point
  const positions = new ObjectArrayView(THREE.Vector3, (segments + 1) * points.length);
  const normals   = new ObjectArrayView(THREE.Vector3, (segments + 1) * norms.length);
  let positionCounter = 0;
  const faceRangeOffsets = new Uint32Array((segments) * (points.length - 1) + 1);//number of faces
  const faceValueIndices = new Uint32Array((segments) * (points.length - 1) * 4);//number of faces*4
  let indCounter = 0;
  const uvValues = new ObjectArrayView(THREE.Vector2, (segments + 1) * points.length);
  let uvCounter = 0;

  segments = segments || 12;
  phiStart = phiStart || 0;
  phiLength = phiLength || 2 * Math.PI;

  const inversePointLength = 1.0 / (points.length - 1);
  const inverseSegments = 1.0 / segments;

  faceRangeOffsets[0] = 0;
  let faceCounter = 1;

  const tempUV = new THREE.Vector2();
  const vertex = new THREE.Vector3();
  const normal = new THREE.Vector3();

  const rotationMatrix4 = new THREE.Matrix4().identity();
  const rotationMatrix = new THREE.Matrix3().identity();

  for (let i = 0, il = segments; i <= il; i++) {

    const phi = phiStart + i * inverseSegments * phiLength;
    rotationMatrix4.copy(rotationMatrix4.makeRotationY(phi));
    rotationMatrix.getNormalMatrix(rotationMatrix4);

    const u = i * inverseSegments;

    for (let j = 0, jl = points.length; j < jl; j++) {

      points.getAt(j, vertex);
      norms.getAt(j, normal);

      vertex.applyMatrix3(rotationMatrix);
      normal.applyMatrix3(rotationMatrix);

      vertex.set(
        Math.round(vertex.x * 1000) / 1000,
        Math.round(vertex.y * 1000) / 1000,
        Math.round(vertex.z * 1000) / 1000);

      normal.set(
        Math.round(normal.x * 1000) / 1000,
        Math.round(normal.y * 1000) / 1000,
        Math.round(normal.z * 1000) / 1000);

      positions.setAt(positionCounter, vertex);
      normals.setAt(positionCounter, normal);

      const v = j / (points.length - 1);

      tempUV.set(u, v);
      uvValues.setAt(positionCounter++, tempUV);
    }

  }

  const np = points.length;

  for (let i = 0, il = segments; i < il; i++) {

    for (let j = 0, jl = points.length - 1; j < jl; j++) {

      const base = j + np * i;
      const a = base;
      const b = base + np;
      const c = base + 1 + np;
      const d = base + 1;

      faceValueIndices[indCounter++] = a;
      faceValueIndices[indCounter++] = b;
      faceValueIndices[indCounter++] = c;
      faceValueIndices[indCounter++] = d;
      faceRangeOffsets[faceCounter++] = indCounter;
    }

  }

  const positionsMap = new PolyMap({
    faceRangeOffsets: faceRangeOffsets,
    faceValueIndices: faceValueIndices,
    values: positions,
  });

  const normalMap = new PolyMap({
    faceRangeOffsets: faceRangeOffsets,
    faceValueIndices: faceValueIndices,
    values: normals,
  });

  const uvMap = new PolyMap({
    faceRangeOffsets: faceRangeOffsets,
    faceValueIndices: faceValueIndices,
    values: uvValues,
  });

  const uvMapsByName = new ObjectsByName();
  const name = 'default';
  uvMapsByName.set(name, uvMap);

  const polyMesh = new PolyMesh();
  polyMesh.faceRangeOffsets = positionsMap.faceRangeOffsets;
  polyMesh.positions = positionsMap;
  polyMesh.normalMap = normalMap;
  polyMesh.uvMaps = uvMapsByName;

  return cleanPolyMesh(new PolyMesh(polyMesh));
  //return new PolyMesh( new PolyMesh( polyMesh ) );
}



// WEBPACK FOOTER //
// ./src/polyMesh/geometric/primitives/Lathe.js